import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MultipleFileDownloadService } from './multiple-file-download.service';

export interface IDataDeliverySignedFileModel {
  name?: string;
  description?: string;
  hash?: string;
  mimetype?: string;
  size?: string;
  url?: string;
}

export interface IDataDeliverySignedUrlsResponse {
  published: string;
  files: IDataDeliverySignedFileModel[];
}

export interface IDataDeliverySignedApiPayload {
  productInstances: IDataDeliveryProductModel[];
}

export interface IDataDeliveryProductModel {
  productId: string;
  description?: string;
  deliveryInstances: string[];
}

@Injectable({
  providedIn: 'root',
})
export class DeliveryDownloadService {
  constructor(
    private _httpClient: HttpClient,
    private _multipleFileDownloadService: MultipleFileDownloadService,
  ) {}

  private static _createPayload(productId: string, deliveryId: string): IDataDeliverySignedApiPayload {
    return {
      productInstances: [
        {
          productId,
          deliveryInstances: [deliveryId],
        },
      ],
    };
  }

  public async downloadSingle(productId: string, deliveryId: string): Promise<void> {
    const url = await this._getSignedUrlFromPdxAPI(productId, deliveryId);
    // download delivery file
    await this._multipleFileDownloadService.download([url]);
  }

  private async _getSignedUrlFromPdxAPI(productId: string, deliveryId: string): Promise<string> {
    // creating payload based on productId and deliveryId
    const response = await this._httpClient
      .post<IDataDeliverySignedUrlsResponse>(
        `/api/pdx/v1/signed-data-deliveries`,
        DeliveryDownloadService._createPayload(productId, deliveryId),
      )
      .toPromise();
    if (!response || !response.files || response.files.length === 0 || !response.files[0].url) {
      throw new Error('Failed to retrieve the signed URL');
    }
    return response.files[0].url;
  }
}
